'use client'

import { useOptionalPageAnalytics } from '@/app/context/analytics'

import { NO_APLICA, NOT_SET } from './constants'
import type { ContextualProductListAnalytics } from './types'
import { useProductListTracking, type ProductListTracking } from './useProductListTracking'

/**
 * `useProductListTracking` para un módulo cuyo `item_list_id` se deriva del
 * `page_type` vigente (`<page_type>_<module_type>`, `Listado filtrado.csv`),
 * leído del `PageAnalyticsProvider`: el mismo módulo CMS queda atribuido a la
 * página anfitriona (home, plp, microsite…) sin conocerla.
 *
 * `analytics` opcional: sin él (tests, consumidores sin instrumentar) o fuera
 * del provider no emite nada y no falla. `enabled` indica si hay config con la
 * que envolver las cards.
 */
export function useContextualProductListTracking(
  analytics: ContextualProductListAnalytics | undefined,
): ProductListTracking & { readonly enabled: boolean } {
  const pageAnalytics = useOptionalPageAnalytics()
  const tracking = useProductListTracking(
    {
      itemListId: `${pageAnalytics?.context.page_type ?? NOT_SET}_${analytics?.moduleType ?? NO_APLICA}`,
      itemListName: analytics?.itemListName ?? NO_APLICA,
      moduleName: analytics?.moduleName ?? NO_APLICA,
      moduleType: analytics?.moduleType ?? NO_APLICA,
      modulePosition: analytics?.modulePosition ?? NO_APLICA,
    },
    analytics
      ? {
          trackViewItemList: pageAnalytics?.trackViewItemList,
          trackSelectItem: pageAnalytics?.trackSelectItem,
          trackAddToCart: pageAnalytics?.trackAddToCart,
        }
      : {},
  )
  return { ...tracking, enabled: analytics !== undefined && pageAnalytics !== null }
}
